// extracted by css-extract-rspack-plugin
export default {"layer":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-ParticleLayer-ParticleLayer-module__layer-tIU76J","particle":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-ParticleLayer-ParticleLayer-module__particle-uXDuaB"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"layer\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-ParticleLayer-ParticleLayer-module__layer-tIU76J\",\"particle\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-ParticleLayer-ParticleLayer-module__particle-uXDuaB\"}";
        // 1793872692228
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  